// Each selected game's share of total traffic, with the total in the middle.
import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { CHART_THEME } from '../../Concession/charts/chartTheme';

const fmt = (n) => (typeof n === 'number' ? Math.round(n).toLocaleString() : '--');

export default function TrafficShareDonut({ slices, total, centerLabel }) {
  const data = useMemo(() => ({
    labels: slices.map((s) => s.label),
    datasets: [{
      data: slices.map((s) => s.value),
      backgroundColor: slices.map((s) => s.color),
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  }), [slices]);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    cutout: '68%',
    animation: { duration: 350 },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: 'rgba(17, 24, 39, 0.92)',
        titleFont: { family: CHART_THEME.font, weight: '600' },
        bodyFont: { family: CHART_THEME.font },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) => {
            const share = total ? Math.round((ctx.raw / total) * 100) : 0;
            return ` ${fmt(ctx.raw)} people (${share}%)`;
          },
        },
      },
    },
  }), [total]);

  return (
    <div className="rx-donut">
      <div className="rx-donut-chart">
        <Doughnut data={data} options={options} />
        <div className="rx-donut-center">
          <strong>{fmt(total)}</strong>
          <span>{centerLabel}</span>
        </div>
      </div>
      <ul className="rx-donut-legend">
        {slices.map((s) => (
          <li key={s.key}>
            <span className="cx-ov-swatch" style={{ background: s.color }} />
            <span className="rx-donut-name">{s.label}</span>
            <span className="rx-donut-val">{fmt(s.value)}</span>
            <span className="rx-donut-share">{total ? Math.round((s.value / total) * 100) : 0}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
